var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    viewBox: "0 0 586 586",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.421 58C249.986 58 209.289 74.8571 179.284 104.863C149.278 134.869 132.421 175.565 132.421 218V342.8L97.0073 396.133C92.7626 402.678 90.355 410.243 90.0363 418.037C89.7177 425.831 91.4998 433.567 95.196 440.437C98.8923 447.306 104.367 453.055 111.047 457.083C117.727 461.112 125.367 463.27 133.167 463.333H451.674C459.525 463.307 467.222 461.158 473.95 457.114C480.679 453.069 486.188 447.28 489.895 440.36C493.601 433.439 495.366 425.645 495.003 417.802C494.641 409.96 492.163 402.362 487.834 395.813L452.421 342.8V218C452.421 175.565 435.564 134.869 405.558 104.863C375.552 74.8571 334.855 58 292.421 58Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.421 527.333C305.643 527.318 318.536 523.208 329.328 515.568C340.12 507.928 348.28 497.133 352.688 484.667H232.154C236.562 497.133 244.722 507.928 255.514 515.568C266.305 523.208 279.199 527.318 292.421 527.333Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell0);
export default __webpack_public_path__ + "static/media/bell_0.3d5c4bc303510962574970a23df4258b.svg";
export { ForwardRef as ReactComponent };